<template>
  <div class="reserve">
    <reserveList ref="list"></reserveList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import reserveList from './reserveList.vue'

export default {
  components: {
    reserveList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.reserve {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/reserve/reserve.vue